import React from 'react';
import ReactApexChart from 'react-apexcharts';

import { useTheme } from 'styled-components';

interface ISimpleDonutGeneralProps {
  displayProjectsAmount: number;
  materialProjectsAmount: number;
  sponsorshipProjectsAmount: number;
  adversityProjectsAmount: number;
  folderProjectsAmount: number;
  sampleProjectsAmount: number;
  eventProjectsAmount: number;
  rebateProjectsAmount: number;
}

const SimpleDonutGeneral: React.FC<ISimpleDonutGeneralProps> = ({
  displayProjectsAmount,
  materialProjectsAmount,
  sponsorshipProjectsAmount,
  adversityProjectsAmount,
  folderProjectsAmount,
  sampleProjectsAmount,
  eventProjectsAmount,
  rebateProjectsAmount,
}: ISimpleDonutGeneralProps) => {
  const { colors } = useTheme();

  const optionColors = [
    colors.chartDisplay,
    colors.chartMaterial,
    colors.chartSponsorship,
    colors.chartAdversity,
    colors.chartFolder,
    colors.chartSample,
    colors.chartEvent,
    colors.chartRebate,
  ];

  const series = [
    displayProjectsAmount,
    materialProjectsAmount,
    sponsorshipProjectsAmount,
    adversityProjectsAmount,
    folderProjectsAmount,
    sampleProjectsAmount,
    eventProjectsAmount,
    rebateProjectsAmount,
  ];

  const options = {
    labels: [
      'Displays',
      'Materiais',
      'Pagamentos',
      'Problemas',
      'Pastas',
      'Amostras',
      'Eventos',
      'Rebate',
    ],
    colors: optionColors,
    dataLabels: {
      enabled: true,
      formatter: (value: number) => {
        return `${Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value)}%`;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return <ReactApexChart options={options} series={series} type="donut" />;
};

export default SimpleDonutGeneral;
